// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../../action-list';
import {createSpaClaim} from './validate-claim';
import {getUpdatedSpaClaim} from '../services/update-spa-claim';
import {isActionResetFormValidation} from '../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedSpaClaim(getState().claims.spa.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_SPA_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_SPA
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_SPA_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createSpaClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/update-selected-action.js